import React, { useCallback } from 'react'
import NeoLoader from './NeoLoader'
import NeoButton from '../../components/NeoButton/NeoButton'
import OtpInput from 'react-otp-input'
import { useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import MediumModal from '../Modal/MediumModel'
import Modal from '../Modal/Modal'
import 'custom/styles/color_variable.css'
import { DIALOG_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function NeoOTPVerify({ onSubmit, otp, setOTP, loading }) {
  const handleChange = (val) => setOTP(val)
  const history = useHistory()
  const {t}= useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='row'>
          <div className='col-12'>
            <div className='my-4'>
              <h6 className='font-weight-bolder log-out-text mx-4' style={{ fontStyle: 18 }}>
                {t(DIALOG_KEYS.CANCEL_MESSAGE)}
              </h6>
            </div>
          </div>
          <div className='col-6'>
            <NeoButton
              mode='newDesign'
              text={t(DIALOG_KEYS.YES)}
              type='button'
              onClick={async () => history.push('/login')}
            />
          </div>
          <div className='col-6'>
            <div
              style={{ textAlign: 'left', marginTop: 10 }}
              className='back-cancel-style text-center'
              onClick={hideModal}>
              {t(DIALOG_KEYS.CANCEL)}
            </div>
          </div>
        </div>
      </Modal>
    ),
    [],
  )

  return (
    <div className='my-4 py-4 d-flex xsflex-column text-center'>
      <div className='col-8 mx-auto'>
        <div className='form-group colored-input'>
          <h4 className='font-weight-bold' style={{marginBottom:20}}>{t(DIALOG_KEYS.ENTER_OTP)}</h4>
          <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={4}
            separator={''}
            isInputNum={true}
            isInputSecure={true}
            shouldAutoFocus={true}
            containerStyle='justify-content-center'
            inputStyle={{
              width: 48,
              height: 48,
              fontSize: 24,
              marginLeft: 8,
              marginRight: 8,
              border: 'none',
              borderRadius: 10,
              backgroundColor: 'var(--otp-background)',
              color: 'var(--otp-text)',
              fontWeight: 800,
              fontSize: 18,
            }}
          />
          <label className='control-label' style={{marginTop:15}}>
            {t(DIALOG_KEYS.OTP_MESSAGE)}
          </label>
        </div>
        {/* <a className="small text-center" href="/">Resend OTP</a> */}
        <div className='mt-4 mx-auto px-0'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              text={t(DIALOG_KEYS.SUBMIT)}
              disabled={otp.length !== 4}
              type='button'
              mode='newDesign'
              onClick={onSubmit}
            />
          )}
        </div>
        <div className='back-cancel-btn-container'>
        <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => showModal()} tabIndex='2'>
        {t(DIALOG_KEYS.CANCEL)}
        </button>
        </div>
      </div>
    </div>
  )
}
